
const quotes = [
    {
        "quote"  : "A robot is not quite a machine. A robot is a machine made to imitate the human being as closely as possible",
        "author" : "Isaac Asimov"
    },
    {
        "quote"  : "What would happen if mankind left the planet and forgot to unplug the last robot.",
        "author" : "Wall-E - Andrew Stanton"
    },
    {
        "quote"  : "How can the Blue Fairy turn a robot into a real live little boy?",
        "author" : "Irobot- SPielberg"
    },
    {
        "quote"  : "I have seen so many things that you humans could not believe. I have seen fabulous rays, C-rays, shining in the shadow of Tannhäuser's door.",
        "author" : "Ridley Scott's, Blade Runner"
    },
    {
        "quote"  : "Hi, I'm C-3PO, specializing in human-cyborg relations. How can I help you?",
        "author" : "George Lucas, Star Wars"
    },
    {
        "quote"  : "I have come to see our conscience as a burden, a weight, and we have spared them (the hosts) that. Anxiety, self-loathing, guilt. The hosts are free. Free, and under my control",
        "author" : "Westworld"
    },
    {
        "quote"  : "The real subject of Real Humans is the interactions between humans and robots. Nothing else",
        "author" : "Realhumans"
    },
    {
        "quote"  : "The mediator between the brain and the hand must certainly be the heart.",
        "author" : "Metropolis"
    },
    {
        "quote"  : "The Machine found a man who was targeted for death. We just didn't know that he was also a killer.",
        "author" : "(Harold Finch) Person of interest"
    },
    {
        "quote"  : "A humanity that would rely too much on machines could run to its ruin.",
        "author" : "Stephen Hawking"
    },
    {
        "quote"  : "The danger in the past was that men would become slaves. The danger in the future is that they become robots.",
        "author" : "Erich Fromm"
    },
    {
        "quote"  : "You are only a slave Neo. The world is a prison where there is no hope or smell or taste. A prison for your spirit. Some things change, some things will never change.",
        "author" : "Neo - Matrix"
    },
    {
        "quote"  : "Man has the possibility not only to think, but also to know that he is thinking! This is what will always distinguish him from the most sophisticated robot.",
        "author" : "Jean Delumeau"
    },
    {
        "quote"  : "A robot is not quite a machine. A robot is a machine made to imitate the human being as closely as possible.",
        "author" : "Isaac Asimov"
    },
    {
        "quote"  : "For me indeed, robots are wonderful tools to think human. They also shed light on the unknown in humans.",
        "author" : "Emmanuelle Grangier"
    },
    {
        "quote"  : "ATCHOUM! Oh I'm sorry, I'm allergic to bullshit!",
        "author" : "I Robot"
    },
    {
        "quote"  : "You think I'm scared of death ? I've done it a million times. I'm fucking great at it. How many times have you died ?",
        "author" : "Maeve - Westworld"
    }
 ]

 export default quotes;